import { HTMLProps } from 'react'
import clsx from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
import { Text } from '@/shared/ui'
import { useAppearance } from '@/shared/utils'
import { IInstitution } from '@/interfaces/institutions'
import { PartnersCard } from './partners-card'
import style from './partners.module.scss'

type PartnersProps = { partners: IInstitution[] } & HTMLProps<HTMLDivElement>

export const Partners = ({ className, partners }: PartnersProps) => {
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    loop: true,
    dragFree: true,
    container: `.${style.slides}`,
  })
  const { ref: cardsRef, animate: cardsAnimate } = useAppearance()
  const translate = useTranslations()

  return (
    <div id="partners" className={clsx(className, style.container)} ref={emblaRef}>
      <Text className={style.heading} color="dark" tagName="h2" type="h3">
        {translate('titlePartners')}
      </Text>

      <motion.div ref={cardsRef} animate={cardsAnimate} className={clsx(style.slides)}>
        <AnimatePresence mode="popLayout">
          {partners?.map((el, index) => {
            if (!el.logo_black?.url) return null
            return <PartnersCard index={index} className={style.slide} key={el.name} svg={el.logo_black.url} />
          })}
        </AnimatePresence>
      </motion.div>
    </div>
  )
}
